var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9237 13.1429L8.4951 0.285714C8.38438 0.0946429 8.19331 0 8.00045 0C7.80759 0 7.61474 0.0946429 7.50581 0.285714L0.0772382 13.1429C-0.142405 13.525 0.132595 14 0.571881 14H15.429C15.8683 14 16.1433 13.525 15.9237 13.1429ZM7.42902 5.28571C7.42902 5.20714 7.49331 5.14286 7.57188 5.14286H8.42902C8.5076 5.14286 8.57188 5.20714 8.57188 5.28571V8.57143C8.57188 8.65 8.5076 8.71429 8.42902 8.71429H7.57188C7.49331 8.71429 7.42902 8.65 7.42902 8.57143V5.28571ZM8.00045 11.5714C7.77615 11.5669 7.56259 11.4745 7.40558 11.3143C7.24857 11.154 7.16063 10.9386 7.16063 10.7143C7.16063 10.4899 7.24857 10.2745 7.40558 10.1143C7.56259 9.95404 7.77615 9.86172 8.00045 9.85714C8.22475 9.86172 8.43832 9.95404 8.59533 10.1143C8.75234 10.2745 8.84028 10.4899 8.84028 10.7143C8.84028 10.9386 8.75234 11.154 8.59533 11.3143C8.43832 11.4745 8.22475 11.5669 8.00045 11.5714Z",
    fill: "#FA2E2E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.7da83517.svg";
export { ForwardRef as ReactComponent };